import PropTypes from "prop-types";
import React from "react";

import { classNames } from "@swa-ui/string";

import { KnownTravelerNumberFormField } from "../KnownTravelerNumberFormField";
import { RedressNumberFormField } from "../RedressNumberFormField";
import styles from "./SecureTravelerFormFields.module.scss";

/**
 * SecureTravelerFormFields combines the KnownTravelerNumberFormField and the RedressNumberFormField
 * components.
 */
export const SecureTravelerFormFields = (props) => {
  const {
    className,
    knownTravelerNumberFieldDescription,
    knownTravelerNumberFieldLabel,
    knownTravelerNumberFieldName,
    redressNumberFieldDescription,
    redressNumberFieldLabel,
    redressNumberFieldName,
  } = props;

  return (
    <div className={classNames(styles.defaultLayout, className)}>
      <KnownTravelerNumberFormField
        description={knownTravelerNumberFieldDescription}
        name={knownTravelerNumberFieldName}
        label={knownTravelerNumberFieldLabel}
      />
      <RedressNumberFormField
        description={redressNumberFieldDescription}
        name={redressNumberFieldName}
        label={redressNumberFieldLabel}
      />
    </div>
  );
};

SecureTravelerFormFields.propTypes = {
  /** Class name for positioning the component. */
  className: PropTypes.string,

  /** An additional description for the known traveler field */
  knownTravelerNumberFieldDescription: PropTypes.string,

  /** The label for the known traveler field. */
  knownTravelerNumberFieldLabel: PropTypes.string,

  /** The form field name for the known traveler field */
  knownTravelerNumberFieldName: PropTypes.string,

  /** An additional description for the redress number field */
  redressNumberFieldDescription: PropTypes.string,

  /** The label for the redress number field. */
  redressNumberFieldLabel: PropTypes.string,

  /** The form field name for the redress number field. */
  redressNumberFieldName: PropTypes.string,
};
